import { useLocation } from "react-router-dom";

import "../../../styles/animations.css";

import StepQuestComplete from "../DetailMultipleChoice/Step/StepQuestComplete";
import Header from "../../../components/v6/Header";
import { cn } from "../../../Utils/helper";
import StepQuestUnderReview from "../DetailMultipleChoice/Step/StepQuestUnderReview";
import { useOnboardingNavigation } from "../../../hooks/useOnboardingNavigation";
import { WAITLIST_DATA } from "../../../components/Onboarding/onboardingData";

function QuestCompletionPage() {
  const location = useLocation();

  const { responseAnswer, questDetailsData } = location.state || {};
  const isCompleted = responseAnswer?.data?.is_completed;

  const { containerProps, onboardingDialog } = useOnboardingNavigation(
    questDetailsData,
    WAITLIST_DATA,
  );

  const activeContainerProps = !isCompleted ? containerProps : {};

  if (typeof isCompleted === "undefined" && !Boolean(isCompleted)) {
    return (
      <div className="flex flex-col mx-auto w-full max-w-[480px] min-h-screen bg-[#ECEEFF]">
        {/* Header */}
        <div className="sticky top-0 left-0 z-50">
          <Header backgroundHeader="bg-transparent" />
        </div>

        {/* Loading content */}
        <div className="flex flex-1 items-center justify-center">
          <div className="text-primary text-lg font-medium">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        {...activeContainerProps}
        className={cn(
          "flex flex-col mx-auto w-full max-w-[480px] overflow-hidden",
          isCompleted ? "bg-[#E1D2F3]" : "bg-[#ECEEFF]",
        )}
      >
        <div className="flex flex-col min-h-screen pt-safe">
          {/* Header */}
          <div
            className={cn(
              "sticky top-0 left-0 w-full z-50",
              isCompleted ? "bg-[#E1D2F3]" : "bg-[#ECEEFF]",
            )}
          >
            <Header backgroundHeader="bg-transparent" />
          </div>

          {/* Content */}
          {isCompleted ? (
            <div className="flex flex-col w-[calc(368px-60px)] 2xs:w-[368px] xs:items-center flex-1 mx-auto scrollbar-hide justify-center pb-safe mb-[126px]">
              <div className="w-full">
                <StepQuestComplete
                  responseAnswer={responseAnswer}
                  questDetailsData={questDetailsData}
                />
              </div>
            </div>
          ) : (
            <StepQuestUnderReview questDetailsData={questDetailsData} />
          )}
        </div>
      </div>
      {onboardingDialog}
    </>
  );
}

export default QuestCompletionPage;
